import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';
import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import { 
  HiPencilAlt
} from "react-icons/hi";

import useUser from '../hooks/useUser';
import CodeSample from './CodeSample';

import '../App.css';

export default function Integration() {
  const { user } = useUser();

  return (
    <Container fluid className="text-start">

      <Card>
        <Card.Body>
          <CodeSample
            codeString={user.shop.data.saastic_account.data.api_token}
          />
        </Card.Body>
      </Card>      
          


    </Container>
  );
}


